import { DENSITY_COLORS, RISK_COLORS } from 'components/Map'
import { getScoreTextColor } from 'utility/Utils'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import {
  ESG_LEGEND,
  ESG_METRICS,
  ESG_NA_COLOR,
} from './layers'

export const Swatch = ({ color, shape = 'circle' }) => (
  <span
    className={`gm-swatch gm-swatch--${shape}`}
    style={{ background: color }}
    aria-hidden
  />
)

const Gradient = ({ colors, from, to }) => (
  <div className="gm-legend-row">
    {from}
    <span
      className="gm-density-scale"
      style={{ background: `linear-gradient(to right, ${colors.join(', ')})` }}
      aria-hidden
    />
    {to}
  </div>
)

const Section = ({ title, children, note }) => (
  <div className="gm-map-legend-section">
    <div className="gm-map-legend-title">{title}</div>
    {children}
    {note ? <div className="gm-layer-note">{note}</div> : null}
  </div>
)

const n = (v) => newFormatThousandSeparator(v)

// Floating key for whatever data layers are currently drawn on the map.
export default function MapLegend({
  layers,
  disabledReason,
  status,
  heatmap,
  esgMetric,
}) {
  const on = (key) => layers[key] && !disabledReason[key]
  const metric = ESG_METRICS.find((m) => m.value === esgMetric)?.label
  const sections = []

  if (on('esg')) {
    const { matched, total, average } = status.esg
    const note = `${n(matched)}/${n(total)} anggota punya skor${
      average != null ? ` · rata-rata ${n(average)}%` : ''
    }`
    sections.push(
      heatmap?.key === 'esg' ? (
        <Section key="esg" title={`Hotspot risiko ESG · ${metric}`} note={note}>
          <Gradient colors={RISK_COLORS} from="Rendah" to="Tinggi" />
        </Section>
      ) : (
        <Section key="esg" title={`ESG · ${metric}`} note={note}>
          <div className="gm-legend-grid">
            {ESG_LEGEND.map(([sample, label]) => (
              <span key={label} className="gm-legend-row">
                <Swatch color={getScoreTextColor(sample)} />
                {label}
              </span>
            ))}
            <span className="gm-legend-row">
              <Swatch color={ESG_NA_COLOR} />
              Tanpa skor
            </span>
          </div>
        </Section>
      ),
    )
  }

  if (heatmap?.key === 'density') {
    sections.push(
      <Section key="density" title="Kepadatan anggota">
        <Gradient colors={DENSITY_COLORS} from="Sedikit" to="Banyak" />
      </Section>,
    )
  }

  return sections.length ? (
    <div className="gm-map-legend" aria-label="Keterangan peta">
      {sections}
    </div>
  ) : null
}
